import {t} from 'ttag';

export const toNull = c => !c ? null : c;

const useLoginFormValidation = (validatorOverride = {}) => {

    const validator = {
        username: ({username: s}) => toNull(!(s && /^.+$/g.test(s))) && [t`Invalid username.`],
        password: ({password: s}) => toNull(!(s && /^.+$/g.test(s))) && [t`Invalid password.`],
        ...validatorOverride
    };

    const isFormDataValid = (formData = {}, formDataValidator = {}) => {
        const dataValidator = {...validator, ...formDataValidator};
        return Object.entries(dataValidator).every(([validatorName, validator]) => {
            return typeof validator === 'function' ? !validator(formData, dataValidator) : !validator;
        });
    };

    return {validator, isFormDataValid, toNull};
};

export default useLoginFormValidation;